
const INITIAL_STATE = {
  data: {},
  errors: {},

}

const GetServiceStatistics = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_STATISTICS_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_STATISTICS_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default GetServiceStatistics;